//import './scss/critical-sb.scss';
import './scss/style-sb.scss';
import './js/fe-core-sb.js';
import FeCore from './js/fe-core-sb.js';

const feCore = new FeCore();